import "./new-subscription.scss";

import { FaChevronLeft } from "react-icons/fa6";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Stepper, StepperChangeEvent } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import NewTransactionWaiver from "@domain/transaction-waiver/new-transaction-waiver/new-transaction-waiver";
import PrintWaiver from "@domain/transaction-waiver/print-waiver/print-waiver";
import { useNewSubscriptionContext } from "../new-subscription.context";
import { useTransactionStepContext } from "@domain/transaction/new-transaction/transaction-step.context";
import TransactionMember from "@domain/transaction/new-transaction/transaction-member/transaction-member";
import ServicePanel from "@domain/transaction/new-transaction/service-panel/service-panel";
import SubscriptionDetails from "../subscription-details/subscription-details";
import SubscriptionSummary from "../subscription-summary/subscription-summary";

export function NewSubscription() {
  const { componentRef, navigate } = useNewSubscriptionContext();
  const {
    stepperRef,
    signaturePreview,
    selectedWaiverPreview,
    nextStepper,
    previousStepper,
    activeStep,
    setActiveStep,
  } = useTransactionStepContext();

  const printSection = (
    <div style={{ display: "none" }}>
      <div ref={componentRef}>
        {selectedWaiverPreview ? (
          <PrintWaiver
            waiver={selectedWaiverPreview}
            signature={signaturePreview}
          />
        ) : null}
      </div>
    </div>
  );

  const memberPanel = (
    <StepperPanel header="Member">
      <TransactionMember
        contextType="subscription"
        {...useNewSubscriptionContext()}
      />
    </StepperPanel>
  );

  const servicePanel = (
    <StepperPanel header="Service">
      <ServicePanel />
    </StepperPanel>
  );

  const subscriptionPanel = (
    <StepperPanel header="Subscription Details">
      <SubscriptionDetails />
    </StepperPanel>
  );

  const waiverPanel = (
    <StepperPanel header="Waiver">
      <NewTransactionWaiver />
    </StepperPanel>
  );

  const summaryPanel = (
    <StepperPanel header="Summary">
      <SubscriptionSummary />
    </StepperPanel>
  );

  const getStepperPanels = () => {
    return [
      memberPanel,
      servicePanel,
      subscriptionPanel,
      waiverPanel,
      summaryPanel,
    ];
  };

  return (
    <div id="NewSubscription" className="subscription">
      <HeaderContent
        title="New Subscription"
        backIcon={<FaChevronLeft />}
        onBack={() => {
          if (activeStep > 0) {
            previousStepper();
          } else {
            navigate("../");
          }
        }}
      />
      {printSection}

      <div className="p-7">
        <section className="grid grid-cols-1 gap-2 mb-4">
          <Stepper
            ref={stepperRef}
            linear={true}
            activeStep={activeStep}
            onChangeStep={(e: StepperChangeEvent) => setActiveStep(e.index)}
          >
            {getStepperPanels()}
          </Stepper>
        </section>
      </div>
    </div>
  );
}

export default NewSubscription;
